import Schema from 'AppReact/schema';

export default {
  selectedOrdersCount: Schema('integer', 'primitive', { defaultValue: 0 }),
  selectedTab: Schema('string', 'primitive', { defaultValue: '' }),
  selectedSavedApplicationsListId : Schema('integer', 'array',{ defaultValue: []} ),
  applications : Schema('integer', 'array',{ defaultValue: []} ),
}